import * as Types from 'src/actions/metrics/get/Types';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { ActionCreator, Dispatch } from 'react-redux';
import ApiClient from 'src/services/api-client/ApiClient';
import { AxiosResponse } from 'axios';
import { RootState } from 'src/reducers/RootReducer';
import Metrics from 'src/entities/Metrics';
import ValidatorService from 'src/services/validation/Validation.service';

export interface GetMetricsAttempt extends Action {
  type: Types.GET_METRICS_ATTEMPT;
}

export interface GetMetricsSuccess extends Action {
  type: Types.GET_METRICS_SUCCESS;
  payload: Metrics;
}

export interface GetMetricsFailure extends Action {
  type: Types.GET_METRICS_FAILURE;
  payload: {};
}

export type GetMetricsAction = GetMetricsAttempt | GetMetricsSuccess | GetMetricsFailure;

export interface GetMetricsThunk extends ThunkAction<Promise<GetMetricsAction>, RootState, string> {
}

export const getMetricsAttempt: ActionCreator<GetMetricsAttempt> = () => (
  {
    type: Types.GET_METRICS_ATTEMPT
  }
);

export const getMetricsSuccess: ActionCreator<GetMetricsSuccess> = (
  metrics: Metrics) => (
  {
    type: Types.GET_METRICS_SUCCESS,
    payload: metrics
  }
);

export const getMetricsFailure: ActionCreator<GetMetricsFailure> = (error: {}) => (
  {
    type: Types.GET_METRICS_FAILURE,
    payload: error
  }
);

export const getMetrics: ActionCreator<GetMetricsThunk> =
  (): GetMetricsThunk => {
    return (dispatch: Dispatch<RootState>): Promise<GetMetricsAction> => {
      dispatch(getMetricsAttempt());

      return ApiClient.metrics.get('')
        .then((response: AxiosResponse<Metrics>): GetMetricsSuccess => {
          const metrics: Metrics = response.data;
          return dispatch(getMetricsSuccess(metrics));
        }).catch((e: { response: { data: { error: {} } } }): GetMetricsFailure => {
          const errorMessages = ValidatorService
          .translateValidations(e && e.response && e.response.data && e.response.data.error);

          return dispatch(getMetricsFailure(errorMessages));
        });
    };
  };



// WEBPACK FOOTER //
// ./src/actions/metrics/get/GetMetrics.actions.tsx